export const UPDATE_GROUP_ANSWER = 'UPDATE_GROUP_ANSWER';
export const POPULATE_GROUP_ANSWERS = 'POPULATE_GROUP_ANSWERS';
